export default class AddSetToSet {
    config() {
        return {
            title: 'Add a collection to another collection',
            description: 'Choose a existing collection to add to this collection.',
            mode: 'single',
            media: false,
            sets: true,
            upload: {
                allow: false,
            },
            defaultFilters: [],
            filterOptions: [],
        };
    }
    doAction() {
        console.log('AddSetToSet::doAction()');
        const options = App.$store.getters.getMediaSelectOptions;
        const itemTypes = App.$store.getters.getMediaSelectSelectedByType;

        return new Promise((resolve) => {
            App.$store
                .dispatch('updateSet', {
                    id: options.itemId,
                    data: {
                        children: itemTypes.sets,
                    },
                })
                .then((response) => {
                    resolve(response);
                });
        });
    }
}
